"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const KeyboardArrowLeft_1 = __importDefault(require("@mui/icons-material/KeyboardArrowLeft"));
const KeyboardArrowRight_1 = __importDefault(require("@mui/icons-material/KeyboardArrowRight"));
const material_1 = require("@mui/material");
const zustandStore_1 = require("../../../../zustandStore");
const emptyMyCardsListWallet_1 = __importDefault(require("../emptyWallet/emptyMyCardsListWallet"));
const emptyWallet_1 = __importDefault(require("../emptyWallet/emptyWallet"));
const myCardItem_1 = __importDefault(require("./myCardItem"));
const MyCardsList = () => {
    const { cards, pager, currentWalletPage, setCurrentWalletPage } = (0, zustandStore_1.useZustand)(state => ({
        cards: state.wallet.cards,
        pager: state.wallet.pager,
        currentWalletPage: state.wallet.pager.currentPage,
        setCurrentWalletPage: state.setCurrentWalletPage,
    }));
    const handlePrevClick = () => {
        const prevPageToSet = pager.currentPage - 1;
        setCurrentWalletPage(Math.max(prevPageToSet, 0));
    };
    const handleNextClick = () => {
        setCurrentWalletPage(pager.currentPage + 1);
    };
    const isPrevDisabled = pager.currentPage <= 0;
    const isNextDisabled = pager.shouldDisableNextArrow;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, spacing: 2, style: { overflow: 'auto' }, "data-testid": "my-cards-list", children: cards?.length > 0 ? (cards.map((task, index) => (0, jsx_runtime_1.jsx)(myCardItem_1.default, { task: task }, index))) : pager.currentPage === 0 ? ((0, jsx_runtime_1.jsx)(emptyWallet_1.default, {})) : ((0, jsx_runtime_1.jsx)(emptyMyCardsListWallet_1.default, {})) }), cards?.length === 0 && currentWalletPage === 0 ? null : ((0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, sx: {
                    justifyContent: 'center',
                    gap: 2,
                    alignItems: 'center',
                    padding: '16px',
                    height: '73px',
                }, children: [(0, jsx_runtime_1.jsxs)(material_1.IconButton, { name: "keyboardArrowLeft", "ts-variant": 'pagerButton', onClick: handlePrevClick, disabled: isPrevDisabled, children: [(0, jsx_runtime_1.jsx)(KeyboardArrowLeft_1.default, {}), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: "PREVIOUS " })] }), (0, jsx_runtime_1.jsxs)(material_1.IconButton, { name: "keyboardArrowRight", "ts-variant": 'pagerButton', onClick: handleNextClick, disabled: isNextDisabled, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: "NEXT" }), (0, jsx_runtime_1.jsx)(KeyboardArrowRight_1.default, {})] })] }))] }));
};
exports.default = MyCardsList;
